import { Control } from "./Control.js";

export class Component extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        this.controls = [];

    };

    // --------------------------------------------------------------------------------------------

    getControls() {

        return this.controls;

    };

    // --------------------------------------------------------------------------------------------

    async prepare(options) {

        await super.prepare(options);
        await Promise.all(this.getControls().map(control => control.prepare(options)));

    }

    async refresh(options) {

        await super.refresh(options);
        await Promise.all(this.getControls().map((control) => control.refresh(options)));

    };

    // --------------------------------------------------------------------------------------------

    mountControl(control, invalidate = false) {

        if (!control)
            return null;
        if (this.controls.includes(control))
            throw new Error('[Component] Control is already mounted.');
        if (control.parent)
            throw new Error('[Component] Control is already mounted in another component.');

        this.controls.push(control);
        control.parent = this;

        if (invalidate)
            this.invalidate();

        return control;

    };

    unmountControl(control, invalidate = false) {

        if (control.parent != this)
            throw new Error('[Component] Control is mounted in another component.');

        var index = this.controls.indexOf(control);
        if (index < 0)
            return;

        this.controls.splice(index, 1);
        control.parent = null;
        
        if (invalidate)
            this.invalidate();

    };

    unmountAllControls(invalidate = false) {

        this.controls.splice(0, this.controls.length);

        if (invalidate)
            this.invalidate();

    };

    // --------------------------------------------------------------------------------------------

    render(renderer, vm = null) {

        if (!this._rendererView) {
            this._rendererView = renderer.createView((viewModel, component) => () => component._render(renderer, viewModel), this);
        }

        return renderer.injectView(this._rendererView, this);

    };

    /**
     * RendererContract view node renderer.
     * @param {*} r - RendererContract implementation
     * @param {*} vm - Component DOM-VM viewmodel
     * @returns DOM-VM element node.
     */
    _render(r, vm) {

        return r.el('div', null, null, [
            '[Component]'
        ]);

    };

    invalidate(level = 0) {

        const parent = this.getParent();

        if (parent && level > 0) {
            parent.invalidate(--level);
            return;
        }

        const rendererView = this._rendererView;

        if (level <= 0 && rendererView) {
            rendererView.redraw();
            return;
        }
        if (parent) {
            parent.invalidate(--level);
        }

    };


}